/*:: type Entry = {
  context: any;
  updated: number;
  value: Object;
}*/

/*:: type CacheSet = Array<Entry>;*/
const TTL = 30000;

const applyAll = (input
/*: Object*/
, entries
/*: Array<Entry>*/
) => entries.reduce((acc, entry) => Object.assign(acc, entry), input);

const matchContext = (context
/*: Object*/
, entryContext
/*: Object*/
) =>
/*: boolean*/
{
  const keys = Object.keys(context);
  if (keys.length !== Object.keys(entryContext).length) return false;
  return !keys.some(key => context[key] !== entryContext[key]);
};

class EnrichmentCache {
  constructor() {
    this.cache = [];
    this.applyAll = applyAll;
  }

  write(context
  /*: any*/
  , updates
  /*: Object*/
  ) {
    this.cache.push({
      context,
      value: updates,
      updated: Date.now()
    });
  }

  read(context
  /*: Object*/
  ) {
    const expiry = Date.now() - TTL;
    const {
      updates,
      invalidations
    } = this.cache.reduce((acc, entry, index) => {
      if (entry.updated < expiry) {
        acc.invalidations.push(index);
      } else if (matchContext(context, entry.context)) {
        acc.updates.push(entry.value);
      }

      return acc;
    }, {
      updates: [],
      invalidations: []
    }); // Purge expired

    this.cache = this.cache.filter((entry, index) => !invalidations.includes(index));
    return updates;
  }

  writeTap(context
  /*: any*/
  , block
  /*: any => Object*/
  ) {
    return (result
    /*: any*/
    ) => {
      this.write(context, block(result));
      return result;
    };
  }

  readTap(context
  /*: Object*/
  , block
  /*: (any, Array<Entry>) => void*/
  ) {
    return (result
    /*: any*/
    ) => {
      const entries = this.read(context);
      block(result, entries);
      return result;
    };
  }

}

module.exports = EnrichmentCache;